<template>
    <Pie
        :chart-id="getID"
        :chart-options="JsChartOptions1"
        :chart-data="getDataSet"
        :height=getHeight
    />
</template>

<script>
import {Bar, Line, Pie} from "vue-chartjs";

export default {
    name: "PieChartBox",
    props: {
        getDataSet: '',
        getID: '',
        getHeight: '',
    },
    components: {
        Bar,
        Pie,
        Line,
    },
    data(){
        return {
            JsChartOptions1: {
                responsive: true,
                maintainAspectRatio: false,
            },
        }
    }
}
</script>

<style scoped>

</style>
